<template>
  <div class="department-wrap style5 ptb-100 bg-albastor">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="dp-content">
            <div class="content-title style1">
              <span>How We Work</span>
              <h2>Our Doctors Help You Awaken Talent & Take You Forward</h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-eye"></i>
                </div>
                <div class="feature-text">
                  <h5>Opthalomologist &amp; Eye Care Service</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque .
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-biometric-recognition"></i>
                </div>
                <div class="feature-text">
                  <h5>We Provide Eye Care Advice</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-retinal-scan"></i>
                </div>
                <div class="feature-text">
                  <h5>Glasses Work Better Than Lenses</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="dp-img-wrap">
            <img src="../../assets/images/dp-img-1.jpg" alt="Image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowWeWork",
};
</script>